import apiClient from './apiClient';
const URL = process.env.REACT_APP_API_URL + "/notas-autorizacion-nuevo";

export const getMisNotasNuevo = async () => {
  try {
    const response = await apiClient(`${URL}/mis-notas`, {
      method: "GET",
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Error al obtener mis notas");
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const subirNotaDeAutorizacionNuevo = async (notaId, archivo) => {
  const formData = new FormData();
  formData.append("file", archivo);
  try {
    const response = await apiClient(`${URL}/${notaId}/upload`, {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Error al subir la nota de autorización");
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const reemplazarPdfNotaAutorizacionNuevo = async (notaId, archivo) => {
  const formData = new FormData();
  formData.append("file", archivo);
  try {
    const response = await apiClient(`${URL}/${notaId}/reemplazar-pdf`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Error al reemplazar el PDF de la nota de autorización");
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteNotaAutorizacionNuevo = async (notaId) => {
  try {
    const response = await apiClient(`${URL}/${notaId}`, {
      method: "DELETE",
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Error al eliminar la nota de autorización");
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const getNotaByIdNuevo = async (notaId) => {
  try {
    const response = await apiClient(`${URL}/${notaId}`, {
      method: "GET",
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Error al obtener la nota de autorización");
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const editNotaAutorizacionNuevo = async (notaId, payload) => {
  try {
    const response = await apiClient(`${URL}/${notaId}/editar`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.message || `Error ${response.status}`);
    }

    return await response.blob();
  } catch (error) {
    throw error;
  }
};

export const generarPdfNotaAutorizacionNuevo = async (payload) => {
  try {
    const response = await apiClient(`${URL}/generar-pdf`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      let errorMsg = '';
      if (errorData?.errors && typeof errorData.errors === 'object') {
        const errorLines = [];
        const extractMsgs = (obj) => {
          for (const [, val] of Object.entries(obj)) {
            if (Array.isArray(val)) {
              errorLines.push(...val);
            } else if (val && typeof val === 'object') {
              extractMsgs(val);
            } else if (typeof val === 'string') {
              errorLines.push(val);
            }
          }
        };
        extractMsgs(errorData.errors);
        if (errorLines.length > 0) {
          errorMsg = errorLines.join('. ');
        }
      }
      if (!errorMsg) {
        errorMsg = errorData?.message || `Error ${response.status}`;
      }
      throw new Error(errorMsg);
    }

    const blob = await response.blob();
    const emailDestinatario = response.headers.get('x-destinatario-email') || '';

    return { blob, emailDestinatario };
  } catch (error) {
    throw error;
  }
};

